import { useQueryPartners } from "features/partners/data";

export const usePartners = useQueryPartners;